// Generates a shareable "I GOT REKT" PNG card and triggers Web Share API,
// clipboard copy, and X intent fallback — one tap.

const CARD_W = 1200;
const CARD_H = 630; // classic social OG size

export function generateShareCard(score, best, drawCharacter) {
  const cvs = document.createElement("canvas");
  cvs.width = CARD_W;
  cvs.height = CARD_H;
  const ctx = cvs.getContext("2d");

  // Background gradient
  const bg = ctx.createLinearGradient(0, 0, 0, CARD_H);
  bg.addColorStop(0, "#1a0b2e");
  bg.addColorStop(0.6, "#431478");
  bg.addColorStop(1, "#9945ff");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, CARD_W, CARD_H);

  // Grain / scanlines
  ctx.save();
  ctx.globalAlpha = 0.15;
  for (let y = 0; y < CARD_H; y += 4) {
    ctx.fillStyle = "#000";
    ctx.fillRect(0, y, CARD_W, 2);
  }
  ctx.restore();

  // Stars
  ctx.fillStyle = "#fff";
  for (let i = 0; i < 60; i++) {
    const x = Math.random() * CARD_W;
    const y = Math.random() * CARD_H * 0.7;
    ctx.globalAlpha = 0.3 + Math.random() * 0.6;
    ctx.beginPath();
    ctx.arc(x, y, Math.random() * 2 + 0.6, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.globalAlpha = 1;

  // Big REKT text
  ctx.save();
  ctx.translate(CARD_W / 2, 220);
  ctx.rotate(-0.06);
  ctx.font = 'bold 220px "Bangers", Impact, sans-serif';
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.lineWidth = 10;
  ctx.strokeStyle = "#000";
  ctx.fillStyle = "#facc15";
  ctx.fillText("REKT", 12, 12);
  ctx.strokeText("REKT", 0, 0);
  ctx.fillStyle = "#ff2d2d";
  ctx.fillText("REKT", 0, 0);
  ctx.restore();

  // Pepe on the left side
  ctx.save();
  ctx.translate(260, 430);
  ctx.scale(4, 4);
  drawCharacter(ctx);
  ctx.restore();

  // Score box on the right
  ctx.save();
  ctx.translate(600, 330);
  ctx.fillStyle = "#39ff14";
  roundRect(ctx, 14, 14, 480, 200, 18);
  ctx.fill();
  ctx.fillStyle = "#fff";
  ctx.strokeStyle = "#000";
  ctx.lineWidth = 10;
  roundRect(ctx, 0, 0, 480, 200, 18);
  ctx.fill();
  ctx.stroke();

  // Labels
  ctx.fillStyle = "#431478";
  ctx.font = 'bold 28px "Press Start 2P", monospace';
  ctx.textAlign = "left";
  ctx.fillText("RUN", 32, 52);
  ctx.fillText("BEST", 262, 52);
  ctx.fillStyle = "#09090b";
  ctx.font = 'bold 88px "Press Start 2P", monospace';
  ctx.fillText(String(score), 32, 150);
  ctx.fillText(String(best), 262, 150);
  ctx.restore();

  // Title ribbon
  ctx.save();
  ctx.fillStyle = "#39ff14";
  ctx.strokeStyle = "#000";
  ctx.lineWidth = 6;
  ctx.translate(60, 60);
  ctx.rotate(-0.04);
  roundRect(ctx, 0, 0, 620, 70, 12);
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = "#000";
  ctx.font = 'bold 26px "Press Start 2P", monospace';
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  ctx.fillText("FLAPPY PEPE · DEGEN", 20, 36);
  ctx.restore();

  // SKILL ISSUE badge bottom
  ctx.save();
  ctx.translate(CARD_W - 420, CARD_H - 100);
  ctx.rotate(0.04);
  ctx.fillStyle = "#ff2d2d";
  ctx.strokeStyle = "#000";
  ctx.lineWidth = 6;
  roundRect(ctx, 0, 0, 360, 56, 10);
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = "#fff";
  ctx.font = 'bold 24px "Press Start 2P", monospace';
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("SKILL ISSUE", 180, 30);
  ctx.restore();

  // Small handle corner
  ctx.save();
  ctx.fillStyle = "#facc15";
  ctx.font = 'bold 20px "Press Start 2P", monospace';
  ctx.textAlign = "left";
  ctx.textBaseline = "alphabetic";
  ctx.fillText("flappypepe.lol", 60, CARD_H - 60);
  ctx.restore();

  return cvs;
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

async function dataURLToBlob(dataUrl) {
  const res = await fetch(dataUrl);
  return res.blob();
}

export async function shareRekt({ score, best, drawCharacter }) {
  const cvs = generateShareCard(score, best, drawCharacter);
  const dataUrl = cvs.toDataURL("image/png");
  const blob = await dataURLToBlob(dataUrl);
  const file = new File([blob], "flappy-pepe-rekt.png", { type: "image/png" });

  const captions = [
    `Got REKT on Flappy Pepe. Score: ${score} · Best: ${best}. Skill issue? Try to beat me 🐸💀`,
    `I just caught ${score} candles before the dump. Flappy Pepe took my soul 🐸📉`,
    `${score} points. Still ngmi apparently. Flappy Pepe is unforgiving 🐸🚀`,
  ];
  const caption = captions[Math.floor(Math.random() * captions.length)];

  // Try Web Share API with files (works on iOS/Android)
  try {
    if (
      navigator.canShare &&
      navigator.canShare({ files: [file] }) &&
      navigator.share
    ) {
      await navigator.share({
        files: [file],
        text: caption,
        title: "I got REKT on Flappy Pepe",
      });
      return { shared: true, method: "web-share" };
    }
  } catch (err) {
    // user cancelled or share failed — fall through to download
  }

  // Fallback: download PNG + copy caption + open X intent
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = "flappy-pepe-rekt.png";
  document.body.appendChild(a);
  a.click();
  a.remove();

  try {
    await navigator.clipboard.writeText(caption);
  } catch (e) {
    // ignore
  }

  // Open X (twitter) intent in a new tab with the caption pre-filled
  const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(caption)}`;
  window.open(url, "_blank", "noopener,noreferrer");

  return { shared: true, method: "download+intent" };
}
